<template>
  <el-dialog title="物料用量信息" width="1070px" :visible="showDialog" :close-on-click-modal="false" @close="closeDialog">
    <el-table
      class="global-table"
      v-loading="loading"
      :data="list"
      border
      :max-height="600"
      highlight-current-row
      show-summary
      :summary-method="getSummaries"
    >
      <el-table-column label="产品名称" min-width="220" prop="materialName"></el-table-column>
      <el-table-column label="规格型号" show-overflow-tooltip prop="specifications" min-width="100"></el-table-column>
      <el-table-column label="单位" show-overflow-tooltip prop="company" min-width="100"></el-table-column>
      <el-table-column label="供应商名称" show-overflow-tooltip prop="supplierName" min-width="100"></el-table-column>
      <el-table-column label="出库量" show-overflow-tooltip prop="operationStock" min-width="100"></el-table-column>
    </el-table>
    <global-pagination
      @size-change="loadList"
      @current-change="loadList"
      :current-page.sync="page"
      :page-size.sync="size"
      :total="total">
    </global-pagination>
  </el-dialog>
</template>

<script>
export default {
  name: 'DetailList',
  props: {
    search: {
      type: Object,
      default: () => {}
    },
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  computed: {
  },
  watch: {
    showDialog (val) {
      if (val) {
        this.page = 1
        this.loadList()
      }
    }
  },
  data () {
    return {
      page: 1,
      size: 10,
      total: 0,
      loading: false,
      list: []
    }
  },
  created () {
  },
  methods: {
    loadList () {
      this.loading = true
      this.$axios.get(this.$apis.material.selectYhDetailedByPage, {
        ...this.search,
        page: this.page,
        size: this.size
      }).then(res => {
        this.list = res.list || []
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    // 关闭
    closeDialog () {
      this.$emit('update:showDialog', false)
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (index === 4) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
          }
        }
      })
      return sums
    }
  }
}
</script>

<style scoped lang="scss">
</style>
